// utils/retryLogic/backoff.ts - utils/retryLogic.ts split (sub-module backoff)


import type {RetryOptions} from './types.js';


export const DEFAULT_OPTIONS: Required<Omit<RetryOptions, 'onRetry' | 'shouldRetry'>> & Pick<RetryOptions, 'onRetry' | 'shouldRetry'> = {
  maxRetries: 3,
  initialDelayMs: 1000,
  maxDelayMs: 30000,
  backoffMultiplier: 2,
};



export const calculateExponentialBackoff = (
  attempt: number,
  initialDelay: number,
  maxDelay: number,
  multiplier: number
): number => {
  const delay = initialDelay * Math.pow(multiplier, attempt - 1);
  return Math.min(delay, maxDelay);
};



export const sleep = (ms: number) => new Promise(resolve => setTimeout(resolve, ms));
